import { Components } from "appworks/components/components";
import { Services } from "appworks/services/services";
import { Contract } from "appworks/utils/contracts/contract";
import { Sequence } from "appworks/utils/contracts/sequence";
import { TGRFreespinIntroComponent } from "components/tgr-freespin-intro";
import { gameLayers } from "game-layers";
import { TGRAddQuickhitSymbolsToReels } from "states/freespins/tgr-add-quickhit-symbols-to-reels";

export class DMFAddQuickhitSymbolsToReels extends TGRAddQuickhitSymbolsToReels {

    public onEnter(): void {
        new Sequence([
            () => Contract.wrap(() => gameLayers.FreespinsIntro.enableBoundsMask(true)),
            () => Components.get(TGRFreespinIntroComponent).enableReelHighlights(),
            () => Contract.wrap(() => Services.sound.customEvent("rainbowchest_win")),
            () => Components.get(TGRFreespinIntroComponent).animateSymbolsSprites(),
            () => Components.get(TGRFreespinIntroComponent).disableReelHighlights()
        ]).then(() => this.complete());
    }
}
